export const NEW_BRANCH_ID = "new-branch";
export const BRANCH_NAME_INPUT_ID = `${NEW_BRANCH_ID}-name`;
export const MIN_LENGTH_BRANCH = 1;
export const BRANCH_LIMIT = 50;
